import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 百度 APP 内置浏览器（X5 / T7 内核）对部分现代 CSS、动效与合成层支持不稳定。
// 命中百度内核 UA 时给根元素打上标记，由样式表整体切换到「安全模式」，
// 关闭动效与渐变模糊，从根上避免「按钮闪一下消失 / 点不动 / 掉色」。
const hdmgdjUa = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
if (/baiduboxapp|baidubox|baidubrowser|bidubrowser|baidubaidu|baidu/i.test(hdmgdjUa)) {
  document.documentElement.classList.add('is-baidu-app');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
